module.exports = __webpack_public_path__ + "img/p3.b7eb6b3d.png";